import { getColorSelector, TargetSelector } from "@client/selectors";
import React from "react";
import { createSelector } from "reselect";

export const makeStyleSelector = () => {
  const separatorColorSelector = getColorSelector(TargetSelector.Entity, "separatorColor");

  return createSelector(
    [separatorColorSelector],
    (separatorColor): React.CSSProperties =>
      ({
        "--separator-color": separatorColor
      } as any)
  );
};
